import { connector } from "../../utils/common/connector";

const controller = "logs";

// ---------------------------------------------
// GET CUSTOMER LOGS BY ID
// ---------------------------------------------
export const getCustomerLogsByIdService = async (params) => {
  let reply;

  try {
    const response = await connector.get(controller, "getCustomerLogsById", {
      ...params,
      dateFrom: params?.dateFrom
        ? encodeURIComponent(params.dateFrom)
        : undefined,
      dateTo: params?.dateTo ? encodeURIComponent(params.dateTo) : undefined,
    });

    reply = {
      logs: response ?? [],
    };
  } catch (error) {
    console.log(error);
    reply = {
      logs: [],
    };
  }

  return reply;
};

// ---------------------------------------------
// GET USER LOGS BY COMPANY (PAGINATED)
// ---------------------------------------------
export const getUserLogsByCompanyService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "getUserLogsByCompany",
      params,
    );

    reply = {
      logs: response?.logs ?? response ?? [],
      totalRecords: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      logs: [],
      totalRecords: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// CREATE CUSTOMER LOG
// ---------------------------------------------
export const createCustomerLogService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "newLog", params);

    reply = {
      logs: response ?? [],
    };
  } catch (error) {
    console.log(error);
    reply = {
      logs: [],
    };
  }

  return reply;
};
